import { render, staticRenderFns } from "./service.vue?vue&type=template&id=3b911fce&scoped=true&"
import script from "./service.vue?vue&type=script&lang=js&"
export * from "./service.vue?vue&type=script&lang=js&"
import style0 from "./service.vue?vue&type=style&index=0&id=3b911fce&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b911fce",
  null
  
)

export default component.exports